(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-slider"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('input', function (event) {
    const input = event.target;
    if (!input.matches('[data-loy-product-range]')) return;
    const comparison = input.closest('.loy-product-compare');
    if (comparison) comparison.style.setProperty('--loy-position', input.value + '%');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loy-ai-comparison"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', function (event) {
    const input = event.target;
    if (!input.matches('[data-loy-ai-range]')) return;
    input.closest('.loy-ai-compare').style.setProperty('--loy-ai-position', input.value + '%');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loy-kit-ritual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('loy-kit-ritual')) {
    customElements.define('loy-kit-ritual', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-ritual-track]');
        this.cards = Array.from(this.querySelectorAll('[data-ritual-card]'));
        this.pause = this.querySelector('[data-ritual-pause]');
        if (!this.track || !this.cards.length) return;
        this.querySelectorAll('[data-ritual-controls]').forEach(control => { control.hidden = false; });
        this.setPaused(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        this.addEventListener('click', event => {
          const time = event.target.closest('[data-ritual-time]');
          if (time && this.contains(time)) {
            this.dataset.time = time.dataset.ritualTime;
            this.querySelectorAll('[data-ritual-time]').forEach(button => button.setAttribute('aria-pressed', String(button === time)));
          }
          if (event.target.closest('[data-ritual-pause]')) this.setPaused(this.dataset.paused !== 'true');
          if (event.target.closest('[data-ritual-next]')) this.goTo(this.currentIndex() + 1);
          if (event.target.closest('[data-ritual-prev]')) this.goTo(this.currentIndex() - 1);
        });
        this.track.addEventListener('scroll', () => this.updateNavigation(), { passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.currentIndex() + (event.key === 'ArrowRight' ? 1 : -1));
        });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
          this.resizeObserver.observe(this.track);
        }
        this.updateNavigation();
      }
      disconnectedCallback() { if (this.resizeObserver) this.resizeObserver.disconnect(); }
      setPaused(paused) {
        this.dataset.paused = String(paused);
        this.pause.setAttribute('aria-pressed', String(paused));
        this.pause.textContent = paused ? this.pause.dataset.labelPlay : this.pause.dataset.labelPause;
      }
      currentIndex() {
        const left = this.track.getBoundingClientRect().left;
        return this.cards.reduce((nearest, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[nearest].getBoundingClientRect().left - left) ? index : nearest, 0);
      }
      goTo(index) {
        const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
        const delta = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollBy({ left: delta, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      updateNavigation() {
        const index = this.currentIndex();
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 6;
        this.querySelector('[data-ritual-prev]').disabled = this.track.scrollLeft <= 6;
        this.querySelector('[data-ritual-next]').disabled = atEnd;
        const right = this.track.getBoundingClientRect().right;
        let lastVisible = index;
        this.cards.forEach((card, i) => { if (card.getBoundingClientRect().right <= right + 6) lastVisible = i; });
        this.querySelector('[data-ritual-status]').textContent = `${index + 1}${lastVisible > index ? '–' + (lastVisible + 1) : ''} / ${this.cards.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loy-routine-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('loy-routine-quiz')) {
  customElements.define('loy-routine-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      try { this.config = JSON.parse(this.querySelector('[data-quiz-config]').textContent); }
      catch { return; }
      this.answers = this.answers || {};
      this.step = this.step || 0;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-quiz-form]');
      this.result = this.querySelector('[data-quiz-result]');
      this.opener = this.querySelector('[data-quiz-open]');
      this.next = this.querySelector('[data-quiz-next]');
      this.templates = new Map([...this.querySelectorAll('template[data-quiz-product]')].map(t => [t.dataset.quizProduct, t]));
      this.opener.hidden = false;
      this.opener.addEventListener('click', () => {
        if (!this.dialog.open) this.dialog.showModal();
        if (this.step < this.config.questions.length) this.renderStep();
        else this.focusResult();
      }, { signal });
      this.querySelector('[data-quiz-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('close', () => this.opener.focus(), { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      this.form.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"], input[type="checkbox"]')) return;
        const question = this.config.questions[this.step];
        if (question.multiple) {
          const chosen = [...this.form.querySelectorAll('input[type="checkbox"]:checked')];
          if (chosen.length > question.max_selections) event.target.checked = false;
          this.answers[question.key] = [...this.form.querySelectorAll('input[type="checkbox"]:checked')].map(input => input.value);
          this.updateSelection();
        } else this.answers[question.key] = event.target.value;
        this.next.disabled = !this.selectionIsValid(question);
      }, { signal });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        const question = this.config.questions[this.step];
        if (!this.selectionIsValid(question)) return;
        this.step += 1;
        this.changeView(() => this.step === this.config.questions.length ? this.renderResult() : this.renderStep());
      }, { signal });
      this.querySelector('[data-quiz-back]').addEventListener('click', () => {
        this.step = Math.max(0, this.step - 1);
        this.changeView(() => this.renderStep());
      }, { signal });
      this.querySelector('[data-quiz-retry]').addEventListener('click', () => {
        this.answers = {};
        this.step = 0;
        this.changeView(() => this.renderStep());
      }, { signal });
      this.renderStep(false);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.viewTransition?.skipTransition();
    }

    changeView(draw) {
      if (this.step === this.config.questions.length || !this.result.hidden) {
        this.viewTransition?.skipTransition();
        this.viewTransition = null;
        draw();
      } else if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.viewTransition?.skipTransition();
        this.viewTransition = document.startViewTransition(draw);
        this.viewTransition.finished.catch(() => {});
      } else draw();
    }

    goals(answers = this.answers) {
      const options = this.config.questions.find(question => question.key === 'goals').options;
      return [...new Set(Array.isArray(answers.goals) ? answers.goals : [])].filter(value => options.some(option => option.value === value));
    }

    optionsFor(question) {
      return question.options;
    }

    selectionIsValid(question) {
      const selected = this.answers[question.key];
      if (question.multiple) return Array.isArray(selected) && selected.length > 0 && selected.length <= question.max_selections && selected.every(value => question.options.some(option => option.value === value));
      return this.optionsFor(question).some(option => option.value === selected);
    }

    updateSelection() {
      const question = this.config.questions[this.step];
      const status = this.querySelector('[data-quiz-selection]');
      status.hidden = !question.multiple;
      if (!question.multiple) return;
      const count = this.goals().length;
      const maximum = question.max_selections;
      status.textContent = this.config.labels.selection_count.replace('__COUNT__', String(count)).replace('__MAX__', String(maximum));
      if (count === maximum) status.textContent += ' ' + this.config.labels.selection_limit;
      this.form.querySelectorAll('input[type="checkbox"]').forEach(input => { input.disabled = !input.checked && count >= maximum; });
    }

    renderStep(focus = true) {
      const question = this.config.questions[this.step];
      if (!question) return;
      this.form.hidden = false;
      this.result.hidden = true;
      this.querySelector('[data-quiz-count]').textContent = this.config.labels.step.replace('__CURRENT__', String(this.step + 1));
      this.querySelector('[data-quiz-progress]').style.width = `${((this.step + 1) / this.config.questions.length) * 100}%`;
      const title = this.querySelector('[data-quiz-title]');
      title.textContent = question.title;
      this.querySelector('[data-quiz-help]').textContent = question.help;
      const holder = this.querySelector('[data-quiz-options]');
      holder.replaceChildren();
      this.optionsFor(question).forEach(option => {
        const label = document.createElement('label');
        label.className = 'loy-quiz__choice';
        const input = document.createElement('input');
        input.type = question.multiple ? 'checkbox' : 'radio';
        input.name = question.key;
        input.value = option.value;
        input.id = `${this.id}-${question.key}-${option.value}`;
        input.checked = question.multiple ? this.goals().includes(option.value) : this.answers[question.key] === option.value;
        input.required = !question.multiple;
        label.htmlFor = input.id;
        const text = document.createElement('span');
        text.textContent = option.label;
        label.append(input, text);
        holder.append(label);
      });
      this.querySelector('[data-quiz-back]').hidden = this.step === 0;
      this.next.textContent = this.step === this.config.questions.length - 1 ? this.config.labels.finish : this.config.labels.next;
      this.next.disabled = !this.selectionIsValid(question);
      this.updateSelection();
      this.dialog.scrollTop = 0;
      if (focus && this.dialog.open) title.focus({ preventScroll: true });
    }

    recommend(answers) {
      const goals = this.goals(answers);
      const younger = answers.age === '30_39';
      const mature = ['40_49', '50_59', '60_plus'].includes(answers.age);
      let family;
      if (answers.skin === 'oily') family = 'a';
      else if (answers.skin === 'dry') family = 'm';
      else if (younger) family = 'a';
      else if (mature) family = 'm';
      else family = goals.includes('firmness') || !goals.some(goal => ['lines', 'glow'].includes(goal)) ? 'a' : 'm';
      let code;
      const complements = [];
      if (goals.length < 1 || goals.length > 3) return { code, complements, extra:null, family };
      if (answers.routine === 'single') {
        if (goals.includes('lines')) code = family === 'm' ? 'm_night' : 'a_night';
        else if (goals.includes('firmness')) code = family === 'm' ? 'm_day' : 'a_day';
        else if (goals.includes('glow')) code = family === 'm' ? 'm_day' : ['oily', 'combination'].includes(answers.skin) ? 'hydra' : 'a_day';
        else if (goals.includes('hydration')) code = 'hydra';
        else code = 'eyes';
        if (goals.includes('eyes') && code !== 'eyes') complements.push('eyes');
        if (goals.includes('hydration') && code !== 'hydra') complements.push('hydra');
      } else {
        const count = { two:'2', four:'4', five:'5' }[answers.routine];
        if (count) code = family + count;
        if (count === '2' && goals.includes('eyes')) complements.push('eyes');
      }
      const extra = ['two', 'four'].includes(answers.routine) && (answers.skin === 'dry' || goals.includes('hydration')) ? family + '5' : null;
      return { code, complements, extra, family };
    }

    isAllowed(code) {
      return Boolean(this.templates.has(code) && !(this.answers.skin === 'oily' && code.startsWith('m')));
    }

    renderCard(code, holder) {
      holder.replaceChildren();
      if (!this.isAllowed(code)) {
        holder.append(this.querySelector('[data-quiz-unavailable]').content.cloneNode(true));
        delete holder.dataset.selectedProduct;
        return false;
      }
      const fragment = this.templates.get(code).content.cloneNode(true);
      fragment.querySelector('[data-quiz-product-description]').textContent = this.config.descriptions[code] || '';
      holder.append(fragment);
      holder.dataset.selectedProduct = code;
      return true;
    }

    renderResult() {
      const selection = this.recommend(this.answers);
      this.form.hidden = true;
      this.result.hidden = false;
      this.querySelector('[data-quiz-reason]').textContent = this.config.labels.selected_goals + ' ' + this.goals().map(goal => this.config.reasons[goal]).join(' · ');
      const available = this.renderCard(selection.code, this.querySelector('[data-quiz-card]'));
      this.querySelector('[data-quiz-gift]').hidden = !available || !['m5', 'a5'].includes(selection.code);
      const complementCards = this.querySelector('[data-quiz-complement-cards]');
      complementCards.replaceChildren();
      if (available) selection.complements.filter(code => this.isAllowed(code)).forEach(code => {
        const holder = document.createElement('div');
        this.renderCard(code, holder);
        complementCards.append(holder);
      });
      this.querySelector('[data-quiz-complements]').hidden = !complementCards.childElementCount;
      this.querySelector('[data-quiz-separate]').hidden = this.answers.routine !== 'two' || !complementCards.childElementCount;
      const hasGel = ['hydra', 'm5', 'a5'].includes(selection.code) || selection.complements.includes('hydra');
      const skinNote = this.querySelector('[data-quiz-skin-note]');
      skinNote.hidden = !available;
      skinNote.textContent = hasGel ? this.config.labels.light_with_gel : this.answers.skin === 'dry' && selection.code !== 'eyes' ? this.config.labels.dry_without_gel : this.config.labels.balanced;
      const retinolNote = this.querySelector('[data-quiz-retinol-note]');
      retinolNote.hidden = !available;
      retinolNote.textContent = this.templates.get(selection.code)?.dataset.retinol === 'true' ? this.config.labels.retinol : this.config.labels.no_retinol;
      const extra = this.querySelector('[data-quiz-extra]');
      extra.open = false;
      extra.hidden = !available || !selection.extra || !this.isAllowed(selection.extra);
      if (!extra.hidden) this.renderCard(selection.extra, this.querySelector('[data-quiz-extra-card]'));
      else this.querySelector('[data-quiz-extra-card]').replaceChildren();
      this.dialog.scrollTop = 0;
      this.focusResult();
    }

    focusResult() {
      if (this.dialog.open) this.result.querySelector('h3').focus({ preventScroll: true });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
